export default "__VITE_ASSET__DBKaPYQd__ 640w, __VITE_ASSET___brEeq1k__ 1024w, __VITE_ASSET__CJ69vjrf__ 1536w";